import { useTl } from ".";
import { usePersonValidators, useDogValidators } from "./validators";
import { useRouter } from "./useRouter";
import { useReferentials } from "./useReferentials";
import React from "react";

export function useApplication() {
  const tlHook = useTl();
  const routerHook = useRouter();
  const usePersonValidatorsHook = usePersonValidators();
  const useDogValidatorsHook = useDogValidators();
  const useReferentialsHook = useReferentials();

  return React.useMemo(
    () => ({
      ...tlHook,
      ...routerHook,
      validators: { person: { ...usePersonValidatorsHook }, dog: { ...useDogValidatorsHook } },
      referentials: { ...useReferentialsHook },
    }),
    [routerHook, tlHook, useDogValidatorsHook, usePersonValidatorsHook, useReferentialsHook]
  );
}
